import each from '../each'

export default {
	...each
}
